function planner(e){
  
var title = ""  
console.log("planner", e.title) 
title = e.title;
  
var customizeNameOpt = document.querySelector('[title="Customize Name (+ $3.00)"]');
var noCustomizeNameOpt = document.querySelector('[title="No Customize Name (+ $0.00)"]');
var addToCartPlanner = document.querySelector('[name="add"]');  

  if (customizeNameOpt != undefined){
  
  		var isSelected = hasClass(customizeNameOpt,"selected");
    
       console.log("isSelected", isSelected)
       
       if (isSelected ==true){
       		 
      document.getElementById('customizeNameOption').style.display = 'block';
  
    document.getElementById("fontGold").checked = true;
   document.getElementById('customizeName').value = '';
       }
  }
  
if (title == 'Customize Name (+ $3.00)'){ 
   
    document.getElementById('customizeNameOption').style.display = 'block';
  
    document.getElementById("fontGold").checked = true;
    document.getElementById('customizeName').value = '';
  
}else if(title == 'No Customize Name (+ $0.00)') { 
      
      resetOption();
     
      
};
  
  
};
  

  
function hasClass(ele,cls) {
return !!ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

function addClass(ele,cls) {
if (!hasClass(ele,cls)) ele.className += " "+cls;
}

function removeClass(ele,cls) {
if (hasClass(ele,cls)) {
  var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
  ele.className=ele.className.replace(reg,' ');
}
}

function resetOption(){

 
   document.getElementById('fontDefault').checked = true;
   document.getElementById('customizeName').value = '';
   
   document.getElementById('customizeNameOption').style.display = 'none';
   
}  
 
function checkError(){
  
   var errorDiv = document.getElementById("error");
   var errorChild = errorDiv.children;
   
   for(var i = 0; i < errorChild.length; i++){
     errorDiv.removedChild(errorChild[i]);
   }
   
}  
  
function doCustomizeValidation(){

  var error = "";
  
  if (document.getElementById("customizeName").value == ""){
  
     error = "<font color='#CC0000'>*</font>This field is required";
     
     document.getElementById("error").style.padding = "20px";
     document.getElementById("error").innerHTML = error;
    
     //document.getElementById('plannerAddCart').disabled = "true";
  }
    
}

 /*  

//Display Customize Name Option
function notcustomize(){
  document.getElementById('customizeNameOption').style.display ='none';
   document.getElementByClassName('customizeChoice')[0].style.display = 'none';
}
function customize(){
  document.getElementById('customizeNameOption').style.display = 'block';
   document.getElementById('fontDefault').setAttribute("checked", "");
  document.getElementById('fontGold').setAttribute("checked", "checked");
}

function doCustomizeValidation(){

  var error = "";
  
  if (document.getElementById("customizeName").value == ""){
  
     error = "<font color='#CC0000'>*</font>This field is required";
     
     document.getElementById("error").style.padding = "20px";
     document.getElementById("error").innerHTML = error;
    
     document.getElementById('plannerAddCart').disabled = "true";
  }
    
}


*/
